import { graphql, withPrefix } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import ReactMarkdown from 'react-markdown'
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import slugify from 'slugify';
import useBusiness from '~lib/useBusiness';

import Header from '~components/graphics/Header';
import Navigation from '~components/graphics/Navigation';
import Sidebar from '~components/graphics/Sidebar';
import MonumentArt from '~components/graphics/MonumentArt';
import Layout from '~components/Layout';

const MonumentSectionStyles = styled.div`
  display: grid;
  grid-template-columns: 500px 1fr;

  .monument__square {
    order: 1;
  }

  .monument__info {
    order: 2;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;

    .monument__group {
      &:first-child {
        order: 1;
      }
    }
  }
`;

const MonumentInfoStyles = styled.div`
  position: relative;
  top: -2px;
  padding: 24px;
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-end: 1;
  grid-row-end: 2;
  border: 1px solid #979797;
  background: #fff;
  overflow: -moz-scrollbars-vertical; 
  overflow-y: scroll;
  // height: calc(100vh - 347px);
  // height: calc(100vh - 325px);
  height: calc(100vh - 332px);
  z-index: 999;
  line-height: 1;
  margin-left: 24px;
  margin-right: 24px;

  img + em {
    font-style: normal;
    font-family: "Benton";
    font-size: 14px;
  }

  .monument {
    display: none;

    &.monument-selected {
      display: block;
    }
  }

  .monument__title {
    font-family: Miller;
    margin-bottom: 12px;
    font-size: 32px;
  }

  .monument__desc {
    font-family: "Georgia";
    line-height: 1.6;
    margin-top: 16px;
    color: #212121;

    p {
      margin-bottom: 24px;

      &:last-child {
        margin-bottom: 0;
        font-style: italic;
        border-top: 1px solid grey;
        padding-top: 16px;
      }
    }
  }

  .monument__person {
    display: none;
  }

  .monument__silhouette {
    height: 75px;
  }

  .monument__info {
    display: grid;
    // grid-template-columns: auto 50%;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;
    margin-bottom: 24px;
  }

  .monument__scale {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 8px;
  }

  .monument__materials-wrapper {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 8px;
    font-family: Benton;
    font-size: 14px;
    line-height: 1.2;
    // border: 1px solid red;
  }

  .monument__artist {
    font-family: Miller;
    font-size: 16px;
    font-weight: 400;
    color: #212121;
  }

  .monument__materials {
    // display: grid;
    // border: 1px solid blue;
  }

  .monument__material {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 8px;
    margin-bottom: 12px;
    // border: 1px solid green;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .monument__material-square {
    height: 16px;
    width: 16px;
    background: #000;
    border: 1px solid #979797;

    &.concrete {
      background: #E0E5E5;
    }

    &.metal {
      background:  #A8B0B2;
    }

    &.glass {
      background: #EBF5FB;
    }

    &.bronze {
      background: #CD7F32;
    }

    &.stone {
      background: #7F7F7F;
    }

    &.marble {
      background: #FBF7EB;
    }

    &.digital-projection {
      background: #D068F2;
    }

    &.solar-panel {
      background: #000000;
    }

    &.water {
      background: #9CD2EB;
    }

    &.fabric {
      background: #F7F4DB;
    }
  }

  .monument__size {
    font-family: Benton;
    font-size: 14px;
    line-height: 1.2;
  }

  @media (max-width: 768px) {
    position: relative;
    top: -3px;
    left: 0;
    border: none;
    height: auto;
    width: 100%;
    overflow-y: initial;
    padding: 24px;
    margin-left: 0;
    margin-right: 0;
  }

  @media (max-width: 360px) {
    .monument__silhouette {
      height: auto;
      max-height: 75px;
    }
  }
`;

const MonumentArtStyles = styled.div`
  // background-image: url("images/Michael_Alfano.jpg");
  background-size: cover;
  background-position: center center;
  // height: 100vh;
  // width: calc(100vw - 500px);

  @media (max-width: 768px) {
    display: none;
  }
`;

const SidebarStyles = styled.div`
  background: #EEF5FD;
  padding-top: 24px;
  padding-bottom: 24px;
  width: 500px;
  z-index: 99;
  // padding-top: 60px;
  padding-top: 54px;

  @media (max-width: 768px) {
    width: 100%;
    padding-bottom: 0;
  }
`;

const HeaderStyles = styled.div`
  text-align: center;
  margin-bottom: 16px;
  margin-top: 8px;

  .header__hed {
    font-size: 48px;
    // max-width: 480px;
    font-family: "Miller";
    font-weight: 400;
    text-align: left;
    line-height: 1;
    // margin: 0 auto;
    margin-left: 24px;
    margin-right: 24px;
  }

  .header__subhed {
    font-size: 18px;
    font-weight: 400;
  }

  @media (max-width: 768px) {
      // width: 90%;
      // margin: 0 auto;
      margin-bottom: 24px;

      .header__hed {
        text-align: center;
        max-width: 480px;
        margin: 0 auto;
      }
  }
`;

const NavigationStyles = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  padding-top: 0;
  align-items: center;
  margin-bottom: 16px;

  .navigation__items-wrapper {
    // height: 115px;
    height: 117px;
    overflow: hidden;
    // border: 1px solid red;
  }

  .navigation__items {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    align-items: start;
    transition: all 200ms ease;
    padding-top: 24px;
    padding-bottom: 24px;

    &.selected-row-1 {
        position: relative;
        top: 0;
        top: -20px;
    }

    &.selected-row-2 {
        position: relative;
        top: -115px;
        top: -127px;
        top: -147px;
    }

    &.selected-row-3 {
        position: relative;
        // top: -232px;
        top: -227px;
        top: -277px;
    }
  }

  .navigation__image {
    width: 50px;
    justify-self: center;
  }

  .navigation__arrow-left,
  .navigation__arrow-right {
    justify-self: center;
    background: none;
    padding: 0;
  }

  .navigation__arrow-left {
    pointer-events: none;
  }

  .navigation__item {
    text-align: center;
    display: grid;
    justify-content: center;
    cursor: pointer;
    border: none;
    background: none;
    text-decoration: none;

    &:active {
      .navigation__title {
        border-bottom: 5px solid #000;
      }
    }
  }

  .item-5,
  .item-6,
  .item-7,
  .item-8,
  .item-9 {
    // display: none;
  }

  .navigation__title {
    font-weight: 700;
    font-family: Benton;
    font-size: 12px;
    line-height: 1.2;
    letter-spacing: 0.25px;
    margin: 0 auto;
    margin-top: 16px;
    color: #000;
    border-bottom: 5px solid transparent;
    padding-bottom: 8px;
    cursor: pointer;
  }

  .fa-angle-left,
  .fa-angle-right {
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .navigation__items-wrapper {
      // height: 107px;
      // height: 100px;
      // height: 92px;
    }

    .navigation__items {
      &.selected-row-1 {
          position: relative;
          // top: -20px;
      }

      &.selected-row-2 {
          position: relative;
          // top: -120px;
          // top: -145px;
          top: -135px;
      }

      &.selected-row-3 {
          position: relative;
          // top: -218px;
          // top: -260px;
          // top: -270px;
          top: -255px;
      }
    }
  }

  @media (max-width: 725px) {
    .navigation__items {
      &.selected-row-3 {
          position: relative;
          // top: -218px;
          // top: -260px;
          // top: -270px;
          top: -265px;
      }
    }
  }

  @media (max-width: 700px) {
    .navigation__items {
      &.selected-row-3 {
          position: relative;
          // top: -218px;
          // top: -260px;
          // top: -270px;
          // top: -265px;
      }
    }
  }

  @media (max-width: 640px) {
    .navigation__items-wrapper {
      // height: 102px;
    }

    .navigation__items {
      grid-column-gap: 16px;

      &.selected-row-3 {
          position: relative;
          // top: -227px;
      }
    }
  }

  @media (max-width: 525px) {
    .navigation__items {
      &.selected-row-3 {
          position: relative;
          // top: -227px;
          top: -285px;
      }
    }
  }

  @media (max-width: 500px) {
    .navigation__items {
      &.selected-row-3 {
          position: relative;
          // top: -227px;
          // top: -285px;
      }
    }
  }

  @media (max-width: 480px) {
    padding: 0;

    .navigation__items-wrapper {
      // height: 98px;
    }
  }

  @media (max-width: 400px) {
    .navigation__items {
      grid-template-columns: repeat(3, 1fr);

      &.selected-row-3 {
          position: relative;
          // top: -210px;
      }
    }
  }
`;

const MonumentInline = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

const MonumentDetail = ({ data }) => {
  const monumentName = `${data.monument.sculpture}`;
  const monumentImage = withPrefix(`images/Size_${data.monument.slug}.png`);
  const monumentInline = withPrefix(`images/main_${data.monument.slug}.jpg`);
  const shareImage = `images/share_${data.monument.slug}.png`;
  
  const monumentColor1 = `monument__material-square ${data.monument.color1}`;
  const monumentColor2 = `monument__material-square ${data.monument.color2}`;
  const monumentColor3 = `monument__material-square ${data.monument.color3}`;

  const monumentArt = `images/main_${data.monument.slug}.jpg`;
  const absoluteImage = `https://apps.bostonglobe.com/opinion/graphics/2022/05/covid-memorial/${shareImage}`;
  const absoluteTitle = `How do we memoralize the pandemic? | ${data.monument.artist}`;
  const absoluteURL = `https://apps.bostonglobe.com/opinion/graphics/2022/05/covid-memorial/${data.monument.slug}`;

  const title = `How do we memorialize the pandemic? | ${data.monument.artist}`;
  const sectionName = 'Opinion';
  const projectName = 'How do we memorialize the pandemic?';

  const slugifiedProjectTitle = slugify(title, { lower: true });
  const slugifiedSection = slugify(sectionName, { lower: true });
  useBusiness({
    environment: process.env.NODE_ENV,
    meterContent: false,
    pageId: `apps.${slugifiedProjectTitle}-monument`,
    section: slugifiedSection,
    author: '',
    projectName,
  });

  return (
    <Layout>
      <Helmet
        title={title}
        meta={[
          {
            property: 'og:image',
            content: absoluteImage,
          },
          {
            name: 'twitter:image',
            content: absoluteImage,
          },
          {
            property: 'og:title',
            content: absoluteTitle,
          },
          {
            name: 'twitter:title',
            content: absoluteTitle,
          },
          {
            property: 'og:url',
            content: absoluteURL,
          },
          {
            name: 'twitter:url',
            content: absoluteURL,
          }
        ]}
      />
     
      <MonumentSectionStyles>
        <SidebarStyles>
          <Header />
          <Navigation data={data.sheet} selectedMonument={data.monument.slug} />

          <MonumentInline>
            <img
              src={monumentInline}
              alt={data.monument.sculpture}
            />
          </MonumentInline>

          <MonumentInfoStyles>
            <div className="monument__info">
              <div className="monument__scale">
                <img
                  src={monumentImage}
                  className="monument__silhouette"
                  alt={data.monument.sculpture}
                />
                <div className="monument__size">{data.monument.size}</div>
              </div>

              <div className="monument__materials-wrapper">
                <p className="monument__materials-title">Materials:</p>

                <div className="monument__materials">
                  {data.monument.material1 !== 'N/A' && (
                    <div className="monument__material">
                      <div className={monumentColor1}></div>
                      <p className="monument__material-name">{data.monument.material1}</p>
                    </div>
                  )}

                  {data.monument.material2 !== 'N/A' && (
                  <div className="monument__material">
                    <div className={monumentColor2}></div>
                    <p className="monument__material-name">{data.monument.material2}</p>
                  </div>
                  )}

                  {data.monument.material3 !== 'N/A' && (
                  <div className="monument__material">
                    <div className={monumentColor3}></div>
                    <p className="monument__material-name">{data.monument.material3}</p>
                  </div>
                  )}
                </div>
              </div>
            </div>

            <p className="monument__title">{data.monument.sculpture}</p>
            <p className="monument__artist">{data.monument.artist}</p>
            <div className="monument__desc"><ReactMarkdown>{data.monument.sculptureDesc}</ReactMarkdown></div>
          </MonumentInfoStyles>
        </SidebarStyles>

        <MonumentArt selectedMonument={data.monument.slug} />
      </MonumentSectionStyles>
      
    </Layout>
  );
};

MonumentDetail.propTypes = {
  data: PropTypes.shape({
    monument: PropTypes.shape({
      additionalImagesInline: PropTypes.string.isRequired,
      artist: PropTypes.string.isRequired,
      background: PropTypes.string.isRequired,
      color1: PropTypes.string.isRequired,
      color2: PropTypes.string.isRequired,
      color3: PropTypes.string.isRequired,
      credit: PropTypes.string.isRequired,
      material1: PropTypes.string.isRequired,
      material2: PropTypes.string,
      material3: PropTypes.string,
      materials: PropTypes.string,
      notes: PropTypes.string.isRequired,
      order: PropTypes.number.isRequired,
      sculpture: PropTypes.string.isRequired,
      sculptureDesc: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    }).isRequired,
    sheet: PropTypes.shape({
      nodes: PropTypes.arrayOf(PropTypes.shape({
        order: PropTypes.number.isRequired,
        sculpture: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      }).isRequired).isRequired,
    }).isRequired,
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        projectName: PropTypes.string.isRequired,
        sectionName: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export const pageQuery = graphql`
    query MonumentDetailQuery($id: String!) {
        site {
            siteMetadata {
                title
                sectionName
                projectName
            }
        }
        monument:  googleSheetSheet1Sheet1(id: {eq: $id}) {
            order
            slug
            artist
            sculpture
            sculptureDesc
            size
            materials
            material1
            color1
            material2
            color2
            material3
            color3
            background
            credit
            additionalImagesInline
            notes
        }
        sheet: allGoogleSheetSheet1Sheet1(sort: {fields: order}) {
            nodes {
                order
                slug
                sculpture
            }
        }
    }
`;

export default MonumentDetail;